"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var MeetingSessionConfiguration_1 = require("../meetingsession/MeetingSessionConfiguration");
var MeetingSessionCredentials_1 = require("../meetingsession/MeetingSessionCredentials");
var DefaultModality_1 = require("../modality/DefaultModality");
var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");
var Types_1 = require("../utils/Types");
var ContentShareConstants_1 = require("./ContentShareConstants");
var DefaultContentShareController = /*#__PURE__*/function () {
  function DefaultContentShareController(mediaStreamBroker, contentAudioVideo, attendeeAudioVideo) {
    _classCallCheck(this, DefaultContentShareController);
    this.mediaStreamBroker = mediaStreamBroker;
    this.contentAudioVideo = contentAudioVideo;
    this.attendeeAudioVideo = attendeeAudioVideo;
    this.observerQueue = new Set();
    this.destroyed = false;
    this.contentAudioVideo.addObserver(this);
    this.setupContentShareEvents();
  }
  _createClass(DefaultContentShareController, [{
    key: "setContentAudioProfile",
    value: function setContentAudioProfile(audioProfile) {
      this.contentAudioVideo.setAudioProfile(audioProfile);
    }
  }, {
    key: "startContentShare",
    value: function startContentShare(stream) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this = this;
        var i;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (stream) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              this.mediaStreamBroker.mediaStream = stream;
              for (i = 0; i < this.mediaStreamBroker.mediaStream.getTracks().length; i++) {
                this.mediaStreamBroker.mediaStream.getTracks()[i].addEventListener('ended', function () {
                  _this.stopContentShare();
                });
              }
              this.contentAudioVideo.start();
              if (this.mediaStreamBroker.mediaStream.getVideoTracks().length > 0) {
                this.contentAudioVideo.videoTileController.startLocalVideoTile();
              }
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "startContentShareFromScreenCapture",
    value: function startContentShareFromScreenCapture(sourceId, frameRate) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var mediaStream;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.mediaStreamBroker.acquireScreenCaptureDisplayInputStream(sourceId, frameRate);
            case 2:
              mediaStream = _context2.sent;
              _context2.next = 5;
              return this.startContentShare(mediaStream);
            case 5:
              return _context2.abrupt("return", mediaStream);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "pauseContentShare",
    value: function pauseContentShare() {
      if (this.mediaStreamBroker.toggleMediaStream(false)) {
        this.forEachContentShareObserver(function (observer) {
          Types_1.Maybe.of(observer.contentShareDidPause).map(function (f) {
            return f.call(observer);
          });
        });
      }
    }
  }, {
    key: "unpauseContentShare",
    value: function unpauseContentShare() {
      if (this.mediaStreamBroker.toggleMediaStream(true)) {
        this.forEachContentShareObserver(function (observer) {
          Types_1.Maybe.of(observer.contentShareDidUnpause).map(function (f) {
            return f.call(observer);
          });
        });
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.contentAudioVideo) {
                _context3.next = 2;
                break;
              }
              return _context3.abrupt("return");
            case 2:
              this.destroyed = true;
              this.contentAudioVideo.removeObserver(this);
              this.stopContentShare();
              this.observerQueue.clear();
              this.contentAudioVideo = undefined;
              this.attendeeAudioVideo = undefined;
              this.mediaStreamBroker = undefined;
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "stopContentShare",
    value: function stopContentShare() {
      this.contentAudioVideo.stop();
      this.mediaStreamBroker.cleanup();
    }
  }, {
    key: "addContentShareObserver",
    value: function addContentShareObserver(observer) {
      this.observerQueue.add(observer);
    }
  }, {
    key: "removeContentShareObserver",
    value: function removeContentShareObserver(observer) {
      this.observerQueue.delete(observer);
    }
  }, {
    key: "forEachContentShareObserver",
    value: function forEachContentShareObserver(observerFunc) {
      var _this2 = this;
      var _iterator = _createForOfIteratorHelper(this.observerQueue),
        _step;
      try {
        var _loop = function _loop() {
          var observer = _step.value;
          AsyncScheduler_1.default.nextTick(function () {
            if (_this2.observerQueue.has(observer)) {
              observerFunc(observer);
            }
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "audioVideoDidStop",
    value: function audioVideoDidStop(_sessionStatus) {
      // If the content attendee got dropped or could not connect, stopContentShare will not be called
      // so make sure to clean up the media stream.
      this.mediaStreamBroker.cleanup();
      if (this.contentShareTile) {
        this.attendeeAudioVideo.videoTileController.removeVideoTile(this.contentShareTile.id());
        this.contentShareTile = null;
      }
      this.forEachContentShareObserver(function (observer) {
        Types_1.Maybe.of(observer.contentShareDidStop).map(function (f) {
          return f.call(observer);
        });
      });
    }
  }, {
    key: "setupContentShareEvents",
    value: function setupContentShareEvents() {
      var _this3 = this;
      // We use realtimeSubscribeToAttendeeIdPresence instead of audioVideoDidStart because audioVideoDidStart fires
      // before the capacity check in Tincan while when realtimeSubscribeToAttendeeIdPresence fires, we know the
      // content attendee has been able to pass the capacity check and join the call so we can start the local
      // content share video
      this.attendeeAudioVideo.realtimeController.realtimeSubscribeToAttendeeIdPresence(function (attendeeId, present, _externalUserId, _dropped) {
        var isContentAttendee = new DefaultModality_1.default(attendeeId).hasModality(DefaultModality_1.default.MODALITY_CONTENT);
        var isSelfAttendee = new DefaultModality_1.default(attendeeId).base() === _this3.attendeeAudioVideo.configuration.credentials.attendeeId;
        if (!isContentAttendee || !isSelfAttendee || !present || _this3.contentShareTile) {
          return;
        }
        var stream = _this3.mediaStreamBroker.mediaStream;
        if (stream === null || stream === void 0 ? void 0 : stream.getVideoTracks().length) {
          _this3.contentShareTile = _this3.attendeeAudioVideo.videoTileController.addVideoTile();
          var track = stream.getVideoTracks()[0];
          var width, height;
          if (track.getSettings) {
            var cap = track.getSettings();
            width = cap.width;
            height = cap.height;
          } else {
            var _cap = track.getCapabilities();
            width = _cap.width;
            height = _cap.height;
          }
          _this3.contentShareTile.bindVideoStream(_this3.contentAudioVideo.configuration.credentials.attendeeId, false, stream, width, height, null, _this3.contentAudioVideo.configuration.credentials.externalUserId);
        }
        _this3.forEachContentShareObserver(function (observer) {
          Types_1.Maybe.of(observer.contentShareDidStart).map(function (f) {
            return f.call(observer);
          });
        });
      });
    }
  }], [{
    key: "createContentShareMeetingSessionConfigure",
    value: function createContentShareMeetingSessionConfigure(configuration) {
      var contentShareConfiguration = new MeetingSessionConfiguration_1.default();
      contentShareConfiguration.meetingId = configuration.meetingId;
      contentShareConfiguration.externalMeetingId = configuration.externalMeetingId;
      contentShareConfiguration.urls = configuration.urls;
      contentShareConfiguration.credentials = new MeetingSessionCredentials_1.default();
      contentShareConfiguration.credentials.attendeeId = configuration.credentials.attendeeId + ContentShareConstants_1.default.Modality;
      contentShareConfiguration.credentials.externalUserId = configuration.credentials.externalUserId;
      contentShareConfiguration.credentials.joinToken = configuration.credentials.joinToken + ContentShareConstants_1.default.Modality;
      return contentShareConfiguration;
    }
  }]);
  return DefaultContentShareController;
}();
exports.default = DefaultContentShareController;